import SaveProspectoCorporativo from "../../shared/component/save_prospecto_corporativo/SaveProspectoCorporativo";

export default function CreateProspectoCorporativoPage() {

  return (
    <SaveProspectoCorporativo title="Crear Prospecto Corporativo" />
  )

}